export interface IdentifyTabData {
    name: string;
    id?: string | number,
    moduleType?: number,
    viewType?: string,
}
export class TabViewModel {
    title: string;
    icon: string;
    unSavedData: boolean;
    confirmActions: string[];
    url: string;
    persistent: boolean = false;
    identifyData: IdentifyTabData;
    meta: any;
    query: any;
    callbackClose: any;
    callBackClearMemory: any;

    constructor(option) {
        this.title = option.title || '';
        this.icon = option.icon || '';
        this.unSavedData = option.unSavedData || false;
        this.confirmActions = option.confirmActions || [];
        this.url = option.url || '';
        this.identifyData = option.identifyData || null;
        this.meta = option.meta || {};
        this.persistent = option.persistent || false;
        this.query = option.query || {};
        this.callbackClose = option.callbackClose || null;
        this.callBackClearMemory = option.callBackClearMemory || null;
    }
}